import { menuItems, type SubMenuItem } from '@/config/menu.config';
import { useCanEditInternals } from '@/hooks/use-developer-mode';
import { usePermissions } from '@/hooks/use-permissions';

/** Whether the current user can view a nav entry gated by `subject`. */
export function useSubjectVisibility(): (subject?: string) => boolean {
	const { ability, isSuperAdmin } = usePermissions();
	return (subject?: string) => !subject || isSuperAdmin || ability.can('view', subject);
}

/** The section's sub-entries the current user can see, in menu order. */
export function useVisibleSubItems(activePrefix: string): SubMenuItem[] {
	const isVisible = useSubjectVisibility();
	const canEditInternals = useCanEditInternals();
	const item = menuItems.find((entry) => entry.activePrefix === activePrefix);
	return item?.subItems?.filter((s) => (s.devOnly ? canEditInternals : true) && isVisible(s.subject)) ?? [];
}
